import React, { useState } from 'react';
import { IconButton, Box } from '@material-ui/core';
import { AppBar, UserMenu } from 'react-admin';
import HelpIcon from '@material-ui/icons/Help';
import HelpDialog from './HelpDialog';

const MyAppBar = (props) => {
    const [helpOpen, setHelpOpen] = useState(false);
    // Extract userMenu from props if it exists, otherwise use UserMenu component
    const { userMenu, children, ...rest } = props;
    
    return (
        <>
            <AppBar {...rest}>
                {children}
                <Box flexGrow={1} />
                <IconButton
                    color="inherit"
                    onClick={() => setHelpOpen(true)}
                    aria-label="help"
                    title="User Guide"
                    style={{ marginRight: 8 }}
                >
                    <HelpIcon />
                </IconButton>
                {userMenu || <UserMenu />}
            </AppBar>
            <HelpDialog open={helpOpen} onClose={() => setHelpOpen(false)} />
        </>
    );
};

export default MyAppBar;

